const moment = require('moment');

function deepEqual(a, b) {
   return JSON.stringify(a) === JSON.stringify(b); // or use lodash.isEqual for better precision
}

function getValueFromPath(obj, path) {
   return path.split('.').reduce((o, key) => (o && o[key] !== undefined) ? o[key] : undefined, obj);
}

function castValue(val, type) {
   if (type === 'boolean') return val === 'true' || val === true;
   if (type === 'number') return Number(val);
   if (type === 'json') return typeof val === 'string' ? JSON.parse(val) : val;
   if (type === 'null') return null;
   return val;
}

function applyOperator(valueA, operator, valueB, type) {
   if (type === 'json') {
      return operator === '==' ? deepEqual(valueA, valueB) : !deepEqual(valueA, valueB);
   }
   switch (operator) {
      case '==':
         return valueA == valueB;
      case '===':
         return valueA === valueB;
      case '!=':
         return valueA != valueB;
      case '!==':
         return valueA !== valueB;
      case '>':
         return valueA > valueB;
      case '<':
         return valueA < valueB;
      case '>=':
         return valueA >= valueB;
      case '<=':
         return valueA <= valueB;
      default:
         throw new Error(`Unsupported operator: ${operator}`);
   }
}

function validateDocument(verConfig, formData, response) {
   if (verConfig?.type === 'custom_1') {
      let isValid = false
      for (let i = 0; i < response?.length; i++) {
         if (response[i]?.status === 'Complete' && response[i]?.results === 'Clear') {
            isValid = true
            break
         }
      }
      return isValid
   } else if (verConfig?.type === 'custom_2') {
      let isValid = true
      if(formData?.licenseNumber !== response?.DOCUMENT_NUMBER) {
         console.log("---formData?.licenseNumber---", formData?.licenseNumber)
         isValid = false
      }
      const respDateOfIssue = moment(response?.DATE_OF_ISSUE, 'MM/DD/YYYY').format('YYYY-MM-DD')
      const respExpirationDate = moment(response?.EXPIRATION_DATE, 'MM/DD/YYYY').format('YYYY-MM-DD')

      if((formData?.effectiveDate || formData?.issueDate) && respDateOfIssue) {
         if(!moment(formData?.effectiveDate || formData?.issueDate, 'YYYY-MM-DD').isSame(respDateOfIssue, 'day')){
            isValid = false
         }
      }

      if((formData?.expirationDate || formData?.expiryDate) && respExpirationDate) {
         if(!moment(formData?.expirationDate || formData?.expiryDate, 'YYYY-MM-DD').isSame(respExpirationDate, 'day')){
            isValid = false
         }
      }

      if(moment(respExpirationDate).isBefore(moment().format('YYYY-MM-DD'))){
         isValid = false
      }

      return isValid
   } else {
      return verConfig.every(rule => {
         let leftValue = getValueFromPath(response, rule.response_path);
         let rightValue;
         if (rule.comparison_type === 'field') {
            rightValue = getValueFromPath(formData, rule.form_path);
         } else {
            rightValue = castValue(rule.form_path, rule.expected_type);
         }

         leftValue = castValue(leftValue, rule.expected_type);
         rightValue = castValue(rightValue, rule.expected_type);
         // console.log("leftValue", leftValue)
         // console.log("rightValue", rightValue)
         // let tmp = applyOperator(leftValue, rule.operator, rightValue, rule.expected_type);
         // console.log("applyOperator", tmp)
         return applyOperator(leftValue, rule.operator, rightValue, rule.expected_type);
      });
   }
}

function formatToSSN(input) {
   // Remove all non-digit characters
   const digits = String(input).replace(/\D/g, '');

   // Ensure it's exactly 9 digits
   if (digits.length !== 9) {
      // throw new Error('Invalid SSN. Must be 9 digits.');
      return input
   }

   // Format as XXX-XX-XXXX
   return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
}

function removeHyphens(input) {
   return String(input).replace(/-/g, '');
}

module.exports = {
   validateDocument,
   formatToSSN,
   removeHyphens
}